import type { AxiosError, AxiosResponse } from 'axios'
import i18n from '@/i18n/index'

export type ApiEnvelope<T> = {
  success: boolean
  data: T
  message?: string
  requestId?: string
}

export function isApiEnvelope<T = unknown>(value: unknown): value is ApiEnvelope<T> {
  if (!value || typeof value !== 'object') return false
  const v = value as Record<string, unknown>
  return typeof v.success === 'boolean' && 'data' in v
}

/**
 * Normalize backend responses.
 * - Preferred backend shape: { success, data, message, requestId }
 * - Legacy shape: response is the data itself
 */
export function unwrapResponseData<T>(response: AxiosResponse<unknown>): T {
  const payload = response.data
  if (isApiEnvelope<T>(payload)) return payload.data
  return payload as T
}

export function getApiErrorMessage(error: unknown, fallbackMessage?: string): string {
  const defaultFallback = i18n.global.t('errors.GENERIC_ERROR') as string
  const axiosError = error as AxiosError<any> | undefined
  return (
    axiosError?.response?.data?.message ||
    (axiosError as any)?.message ||
    fallbackMessage ||
    defaultFallback
  )
}

export function getApiStatus(error: unknown): number | undefined {
  const axiosError = error as AxiosError | undefined
  return axiosError?.response?.status
}

